import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ["paginationBlock"]

  fetchData(event) {
    event.preventDefault();
    const url = event.currentTarget.href
    const that = this
    $.ajax({
      url: url,
      headers: {
        Accept: "application/json",
      },
      success: function (res) {
        var $elem = $(`#${res.id}__show`);

        $elem.html(res.collections);
        that.paginationBlockTarget.innerHTML = res.pagination;

        that.scroll(res.id)
      }
    });
  }

  scroll(id) {
    const element = document.getElementById(id);
    const rect = element.getBoundingClientRect();
    const offset = {
      top: rect.top + window.scrollY,
      left: rect.left + window.scrollX
    };

    window.scrollTo({
      top: offset.top,
      left: offset.left,
      behavior: 'smooth'
    });
  }
}